module.exports = __webpack_public_path__ + "static/media/model-sorento-um15.5572f3a7.jpg";